import { useContext } from 'react';
import { AuthContext } from "State/AuthContext";
import { reAuthoriseToken } from "Api/apiService";
import { ACCESS_TOKEN_KEY } from "constants/localStorage.constants";
import useSessionExpiryTimer from './useSessionExpiryTimer';
import { SbModal, SbButton, BUTTON_TYPE } from "uiCore";


export const decodeToken = (token) => {
    try {
        if (!token || typeof token !== 'string') return null;

        const [, payload] = token.split('.');
        if (!payload) return null;

        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
                .join('')
        );

        return JSON.parse(jsonPayload);
    } catch (err) {
        console.error("Failed to decode token", err);
        return null;
    }
};

const getSessionWarningMinutes = (warningMs) => Math.max(1, Math.ceil(warningMs / (60 * 1000)));

const SessionChecker = () => {
    const { 
        accessToken,
        setAccessToken,
        refreshToken,
        logout
    } = useContext(AuthContext);

    const {
        showSessionModal,
        setShowSessionModal,
        warningMs,
    } = useSessionExpiryTimer({ accessToken, onExpire: logout, decodeAccessToken: decodeToken });

    const warningMinutes = getSessionWarningMinutes(warningMs);

    const handleContinue = () => {
        setShowSessionModal(false);
        sb_auth_reAuthorise();
    };

    const handleLogout = () => {
        logout();
    };

    const sb_auth_reAuthorise = async () => {

        try {
            if (!refreshToken) {
                handleLogout();
                return;
            }

            const reAuthoriseResponse = await reAuthoriseToken(refreshToken);

            if (reAuthoriseResponse?.access_token) {
                localStorage.setItem(ACCESS_TOKEN_KEY, reAuthoriseResponse.access_token);
                setAccessToken(reAuthoriseResponse.access_token);
            } else {
                handleLogout();
            }

        } catch (err) {
            console.error("re authorization unsuccessful:", err);
            handleLogout();
        }
    };

    return (
        <SbModal
            open={showSessionModal}
            title="Session Expiring Soon"
            centered
            width={440}
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={[
                <SbButton key="logout" buttonType={BUTTON_TYPE.SECONDARY} onClick={handleLogout}>
                    Logout
                </SbButton>,
                <SbButton key="continue" buttonType={BUTTON_TYPE.PRIMARY} onClick={handleContinue}>
                    Continue
                </SbButton>,
            ]}
        >
            <p style={{ margin: 0 }}>
                Your session will expire in less than {warningMinutes} {warningMinutes === 1 ? 'minute' : 'minutes'}. Do you want to continue?
            </p>
        </SbModal>
    );
};

export default SessionChecker;
